import { BffRequestBuilder } from "../helpers";
/**
 * @class
 * @classdesc Get data from BFF
 */
var Retriever = /** @class */ (function () {
    function Retriever(bff) {
        this.bff = bff;
    }
    /**
     * @method loadData
     * @description Get data from 'getEventsByIdForBetslip' BFF endpoint
     * @param {BsUtilMsgItem[]} items Items, to be fetched form BFF
     * @param {Function} successCallback Function, to be executed on successfully loaded and processed items
     * @param {Function} errorCallback Function to be executed when error occured
     */
    Retriever.prototype.loadData = function (items, successCallback, errorCallback) {
        var _this = this;
        var request = BffRequestBuilder.buildEventsByEventIdForBetSlipRequest(items);
        return this.bff.getEventsByIdForBetslip(request)
            .then(function (response) {
            successCallback(_this.prepareData(response));
        })
            .catch(errorCallback);
    };
    /**
     * @method prepareData
     * @description Parse loaded data from BFF to BsUtilItem items
     * @param {EventsByEventIdForBetSlipResponse} response Received response from BFF
     * @return {BsUtilItem[]} Processed items
     */
    Retriever.prototype.prepareData = function (response) {
        var items = [];
        response.markets.forEach(function (market) {
            var event = response.events.find(function (e) { return market.eventId === e.id; });
            if (!event || !market.selections) {
                return;
            }
            market.selections.forEach(function (selection) {
                items.push({
                    event: event || {},
                    market: market,
                    selection: selection
                });
            });
        });
        return items;
    };
    return Retriever;
}());
export { Retriever };
//# sourceMappingURL=retriever.js.map